
export function isValidDate(dateString: any): boolean {
    if(dateString === null || dateString === undefined) return false;
    try {
        const date = new Date(dateString);
        return typeof date === 'object' && !isNaN(date.getTime());
    } catch {
        return false;
    }
}